const normalizeErrorResponse = (response) => {
  const { data, status } = response
  if (typeof data === 'string') {
    return new Error(`[${status}]: ${data}`)
  }

  const { errors, title } = data
  if (errors) {
    const validationErrors = errors.$ || errors
    const messages = Array.isArray(validationErrors) ? validationErrors : Object.keys(validationErrors).reduce((arr, key) => [...arr, ...validationErrors[key]], [])
    return new Error(`[${status}]: ${messages.join('\n ')}`)
  }

  return new Error(`[${status}]: ${title}`)
}

export const normalizeError = (error) => {
  // Parse axios error
  if (error.response) {
    // Request made and server responded
    return normalizeErrorResponse(error.response)
  } else if (error.request) {
    // The request was made but no response was received
    return new Error('A network error occurred')
  } else {
    // Something happened in setting up the request that triggered an error
    return error
  }
}
